import { combineReducers } from "redux";
import ReservationTabReducer from "./reservation/ReservationTabReducer";
import ReservationSubTabReducer from "./reservation/ReservationSubTabReducer";
import ReservationChildSubTabReducer from "./reservation/ReservationChildSubTabReducer";
import ReservationProductReducer from "./reservation/ReservationProductReducer";
import ReservationIdReducer from "./reservation/ReservationIdReducer";
import ReservationTransactionReducer from "./reservation/ReservationTransactionReducer";
import ReservationSourceReducer from "./reservation/ReservationSourceReducer";
import ReservationStatusReducer from "./reservation/ReservationStatusReducer";
import ReservationFinancialStatusReducer from "./reservation/ReservationFinancialStatusReducer";
import ReservationAssignToReducer from "./reservation/ReservationAssignToReducer";
import ReservationArrangerReducer from "./reservation/ReservationArrangerReducer";
import ReservationArrangerSnapshotReducer from "./reservation/ReservationArrangerSnapshotReducer";
import ReservationCheckUncheckReducer from "./reservation/ReservationCheckUncheckReducer";
import ReservationTaskReducer from "./reservation/ReservationTaskReducer";
import ReservationTotalReducer from "./reservation/ReservationTotalReducer";
import ReservationBalanceReducer from "./reservation/ReservationBalanceReducer";
import ReservationFinancialBalanceReducer from "./reservation/ReservationFinancialBalanceReducer";
import ReservationCurrencyReducer from "./reservation/ReservationCurrencyReducer";
import ReservationExchangeRateReducer from "./reservation/ReservationExchangeRateReducer";
import ReservationDocStatusReducer from "./reservation/ReservationDocStatusReducer";
import ReservationEmailStatusReducer from "./reservation/ReservationEmailStatusReducer";
import ExchangeRateArrayReducer from "./reservation/ExchangeRateArrayReducer";
import ReservationSalesChannelReducer from "./reservation/ReservationSalesChannelReducer";
import ReservationLogsReducer from "./reservation/ReservationLogsReducer";
import ReservationTransactionSaveReducer from "./reservation/ReservationTransactionSaveReducer";
import ReservationProductSaveReducer from "./reservation/ReservationProductSaveReducer";
import ReservationProducts from "./reservation/ReservationProducts";

const rootReducer = combineReducers({
  reservationProduct: ReservationProductReducer,
  reservationTransaction: ReservationTransactionReducer,
  reservationSource: ReservationSourceReducer,
  reservationTab: ReservationTabReducer,
  reservationSubTab: ReservationSubTabReducer,
  reservationChildSubTab: ReservationChildSubTabReducer,
  reservationId: ReservationIdReducer,
  reservationStatus: ReservationStatusReducer,
  reservationFinancialStatus: ReservationFinancialStatusReducer,
  reservationAssignTo: ReservationAssignToReducer,
  reservationArranger: ReservationArrangerReducer,
  reservationArrangerSnapshot: ReservationArrangerSnapshotReducer,
  reservationCheckedUnchecked: ReservationCheckUncheckReducer,
  reservationTask: ReservationTaskReducer,
  reservationTotal: ReservationTotalReducer,
  reservationBalance: ReservationBalanceReducer,
  reservationFinancialBalance: ReservationFinancialBalanceReducer,
  reservationCurrency: ReservationCurrencyReducer,
  reservationExchangeRate: ReservationExchangeRateReducer,
  reservationDocStatus: ReservationDocStatusReducer,
  reservationEmailStatus: ReservationEmailStatusReducer,
  exchangeRateArray: ExchangeRateArrayReducer,
  reservationSalesChannel: ReservationSalesChannelReducer,
  reservationLogs: ReservationLogsReducer,
  reservationTransactionSave: ReservationTransactionSaveReducer,
  reservationProductSave: ReservationProductSaveReducer,
  reservationProducts: ReservationProducts,
});

export default rootReducer;
